import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderControlService {
  private changeStyleSubject = new Subject<void>();
  changeStyle$ = this.changeStyleSubject.asObservable();
  triggerStyleChange() {
    this.changeStyleSubject.next();
  }

  private changeStyleOldSubject = new Subject<void>();
  changeStyleOld$ = this.changeStyleOldSubject.asObservable();
  triggerStyleOldChange() {
    this.changeStyleOldSubject.next();
  }

  private showHeaderSubject = new BehaviorSubject<boolean>(true);
  showHeader$ = this.showHeaderSubject.asObservable();
  setShowHeader(show: boolean) {
    this.showHeaderSubject.next(show);
  }
}
